import { render, staticRenderFns } from "./FaseFenologicaModal.vue?vue&type=template&id=6b8b8a34&scoped=true"
import script from "./FaseFenologicaModal.vue?vue&type=script&lang=js"
export * from "./FaseFenologicaModal.vue?vue&type=script&lang=js"
import style0 from "./FaseFenologicaModal.vue?vue&type=style&index=0&id=6b8b8a34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8b8a34",
  null
  
)

export default component.exports